var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNyk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B3B2B1;}\r\n\t.st2{fill:#006BB6;}\r\n\t.st3{fill:#FF671B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.4,347.6l-24.1-31.3c-30.7-10.1-52-37.9-54.1-70.1l-15-19.4c-14.2,6.1-28.5,15.8-28.5,15.8l-44.9-45 L51.7,156L18,112h53.8l10.4-22.7l26.6-10.7l2.9-8l21.7,9.8l5.1-18l3.5-1.1c17.1-5.7,36.8-8.7,56.9-8.8c0.6,0,7,0.1,7.2,0.1 c0.7,0,3.8,0.2,3.8,0.2c17.1,0.8,33.1,3.6,47.6,8.4l3.5,1.1l4.7,17.2l7.8-5.9L317.3,89l10.5,23h54.1l-34.2,44.1l18.6,40.9 l-45.6,46.9c0,0-16.7-12.2-28.2-16.7l-13.7,17.7c-1.6,33.1-24,62-55.6,71.8L199.4,347.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "199.5,325.8 355,125.3 44.9,125.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.2,119.1l167.2,217.1l168.4-217.1C367.8,119.1,32.2,119.1,32.2,119.1z M355,125.3L199.5,325.8L44.9,125.3 H355z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.5,139.3l-0.1-0.1l-0.1-0.1l-10-6.7l3.7-7.1l0.1-0.2l-0.1-0.2l-13.7-30.1l-0.1-0.2l-0.2-0.1l-36.8-13.1 l-0.2-0.1l-0.2,0.2L265,89l-0.1,0.1v0.1l-1.7,4.2c0,0-15.3-3.8-37.8-6.1c-2.3-0.2-8.4-0.7-18.2-1.5l-0.9-0.1l-1.1-0.1H205l-0.2,0.2 l-7.3,7.3v-7.5c0,0-20.7,1.1-34.2,3s-26.8,5.2-26.8,5.2l-2.5-5.2l-0.1-0.2l-0.2-0.1l-17.4-8l-0.5-0.2l-0.2,0.5l-2,5.5l-0.4-1.1 l-0.2-0.4l-0.4,0.2l-25,10l-0.2,0.1L87.3,95l-46,101L79,233.8l1.8-1c1.1-0.6,2.7-1.6,4.6-2.7c4.6-2.7,10.8-6.3,13.8-7.8l0.6-0.3 c3.8-1.9,5.8-2.8,24.1-10.7l1.6-0.6c0,0,2.1-0.8,5.8-2.1c10.1-3.3,36.3-11.1,61.7-11.1h0.3c1,0,2,0,3,0c17.3,0.5,37.3,4.2,51.3,7.1 c13.3,2.9,23.4,5.6,26.2,6.4l1.9,0.6c12.6,4.9,28.1,12.9,42.3,22l1.9,1.1l38.2-39.3L332.5,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.3,142.8l-36.7-24.5l-6.3-17.9l11.3,4.1l4.6,11.2l17.3,5.5l-10.1-22.3l-32.7-11.5l-6,4.7l10.8,35.3 l34.9,24.6l8.9,22.3l-14.6-6.6l-5-13.9l-17.8-5.2l9.6,31.4c2.9,1,5.8,2.2,8.7,3.3c7.9,3.2,15.7,6.8,23.3,10.6 c5.3,2.7,10.4,5.5,15.5,8.5l7.6-7.8L328.3,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.7,159.4l12.2-10.9l2.9,3.4l-12.1,34.7c6.7-2.9,13.3-5.6,20.2-8l8.7-28.6l-7.6-12.5l15.6-14.9l9.2-30.5 L118.6,87l-10.1,28.7l-16.2,13.9l14.7-37l-15.9,6.3l-43.7,95.9l6.9,6.9c4.1-2.4,8.2-4.7,12.4-6.8L80.7,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.5,91l-13.4,0.7l-6.3,72c5.7-0.5,11.4-0.9,17.3-1.1L191.5,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.2,148.7l-15.6-0.9l-2.5-44.1l13.2,0.6l-1.6-12.2L207,90.9l-7.9,7.9v55.1l8.3,8.5c8.6,0.3,17.1,0.9,25.5,2 L231.2,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143,119.4l5.6,27.4l-3.6,20.7c5.4-1,10.9-2,16.4-2.7l0,0l8.6-72.2l-12.5,1.8l-4.1,23.6l-4.5-22l-14.7,3.6 L114,175.2c5.8-1.9,11.9-3.4,17.8-4.9L143,119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.2,144.8l4.4-5.9l6.4,5.3l5.9,26.8c6.1,1.6,12.3,3.3,18.3,5.3l-11-39.3l-11.3-9.3l6.4-8.6l-5.4-20l-13.6-3 l5.4,20.1l-8.5,11.3l-6.3-33.1l-12.7-1.6c0,0,6.3,48.5,9.4,72.4c5.7,0.8,11.4,1.8,17.1,2.9L251.2,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.7,177.3c0,0,5.3-3.1,15.8-4.3l-0.3-8.3c-5.8,0.2-11.5,0.5-17.3,1.1C172.4,169.1,173.2,174,173.7,177.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.3,172.5c4.3,0.5,8.8,1.9,12.9,3c3.6,0.8,7.6,2.4,10.8,3.8l1.8-12.8c-8.5-1-16.5-1.7-25.2-2 C207.4,167.2,207.4,170.8,207.3,172.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.7,192.8c4.9-3.6,7.9-7.4,13-10.6c-0.9-4.7-2.3-10.7-3.2-15.3c-5.6,0.7-11.2,1.7-16.7,2.7 C147,176.7,149.7,185.9,151.7,192.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.3,182.1c4.8,2.8,8.5,5.9,12.8,10.1l0.8,0.6l6.8-22.4c-5.8-1.2-11.4-2.3-17.4-3.1L235.3,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.6,201.5l16.1,3.7l13.5-26.7c-6.2-2.1-12.3-3.7-18.6-5.3L256.6,201.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.1,205.2c4.2-1.6,10.1-3.6,15.5-5.1l-10.4-27.7c-6.3,1.6-11.9,3.1-18,5.1 C118.2,186.8,122.5,196.4,127.1,205.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,215.2c0.9-0.8,10.1-4.8,16.3-7.4c-4.8-8.6-10.5-18.1-15.2-26.8c-6.9,2.4-13,5-19.7,7.9L102.9,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.1,227.2c2.9-1.8,6-3.5,9.4-5.5l-21.3-25.2c-4.1,2.1-8.1,4.3-12.1,6.7L80.1,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.1,208.5c12.8,5,30.7,15,37.9,19.8c3.3-3.1,21.1-21.8,23.6-24.4c-14.8-8.7-30.4-16.1-46.6-22L281.1,208.5z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "204.8,172.1 198.7,171.9 198.5,157 204.9,163.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.1,169.2c-39.7,0-72,32.2-72,72c0,39.7,32.2,72,72,72c39.7,0,72-32.2,72-72 C272.1,201.5,239.8,169.2,200.1,169.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.5,174.6c-5.5,2-10.8,4.7-16.1,7.2c-3.6-2.2-5.6-2.7-8.1-4.3C187.8,174.7,196.1,174.3,204.5,174.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.1,205.2c-17-17.1-42.4-15.9-64-21.9c0,0,12.7-6,19.2-7.7C229,178.6,246.1,189.1,256.1,205.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.7,207.7c-16.3,25-18.5,55.8-5.5,82.8c-16.7-14-26.7-41.4-19.2-67.8C142.1,214,150.1,206.4,160.7,207.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.2,225.6c8.7,26.1,10.7,55,33.5,81.3c-17.8,3.6-35.3-1.8-49.3-10.6c-17.4-25.3-15.7-63.1,1.7-87.7 C172.4,211.1,177,222.2,178.2,225.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166,205.9c2.6-3.7,5.6-7.3,8.9-10.5c36.9,10.4,72.1,48.7,78.1,86.2c-1.8,2.8-5.9,6.8-8.8,9.7 c-9.2,8.2-19.2,12.5-28.9,14.8c-17.3-17.9-22.9-41.1-29-64C181.6,224.5,178.4,211.3,166,205.9L166,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.1,205.7c-17.8-15.7-42.6-13.7-63.4-21c-4.1,2.5-8,5.4-11.3,8.4c36.9,11.5,70.4,47.6,78.3,84.9 c5.8-8.3,9.3-18.1,10.7-28.4C267.3,233.8,267.2,219.4,252.1,205.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.9,194.2c-3.5,3.4-6.2,6.8-9,10.7h-0.1c-9.8-2.2-17.5,2.9-23.6,9.2c2.9-7.5,9.2-16.3,15.7-22 C160.9,192.3,165.3,192.2,171.9,194.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174.5,191.9c3.5-3.1,6.9-5.8,11-8.3l-9.5-4.7c-6.3,2.6-13,5.9-17.7,10.2C165.6,189.9,168.7,190.3,174.5,191.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.9,80.9l-2.9,2.9l-5,0.3l-1.9-1.7l-2.4,2l-5.4,0.5l-2.4-2.3l3.1-21.3l4.2-0.5L175,79.7l2.9-0.3l2.3-18.8 l4.1-0.4l-1.7,18.7l2.9-0.3L187,60c1.8-0.2,2.6-0.2,4.2-0.2L189.9,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.2,59.4v13.4h2.6l-0.2-13.3c0,0,2.8,0.1,4,0.2l0.5,15l-2.5,2.5h-0.8l0.1,6.4l-4.5-0.1v-6.4l-0.9-0.1 l-2.7-2.8l0.2-15C200.5,59.4,203.2,59.4,203.2,59.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170,61.9l-0.7,4.4l-5,0.9l-0.9,5.1c1.9-0.3,2.9-0.5,5.1-0.8c-0.3,1.9-0.4,2.6-0.7,4.4l-5,0.7l-0.9,4.9 l5.1-0.7c0,0-0.5,3.3-0.7,4.8c-3.5,0.4-7.2,0.9-10.6,1.6c0,0,3.8-17.9,4.8-23.4L170,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.3,88l-5.2,1l2.4-9.8l-1.6-3.5l-4.2,14l-5.1,1.1c2.1-7.6,4.3-15.2,6.3-22.8c1.8-0.6,3-0.9,4.6-1.5 c0.5,1.2,2,3.8,2,3.8l1.2-4.8c0,0,3.2-0.8,4.8-1.2L151.3,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.2,63.6c0.5,6.1,1.6,12,2.2,17.6l-2.3,3.4l-7.3-0.5l-2.6-2.9c-0.4-6.2-0.8-12.5-1.1-18.7 c0.6-0.9,1.7-1.6,2.5-2.5l6.1,0.6L224.2,63.6z M217.5,64.6l1.4,14.6l2.6,0.2l-1.4-14.5L217.5,64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.9,65.7c0.9,3.5,2.7,10.7,2.7,10.7l1.8,0.3l0.8-1.1l-2.2-8.9c0,0,2.2,0.6,4.5,1.2l2.3,8.6l-1,1.6l2,2.2 l3,10.5l-5-1.1l-2-7.4l-3.1-0.7l1.7,7.4l-5.1-1c-1.8-7.9-5-23.5-5-23.5S246,65.1,247.9,65.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240,66.6l1.7,8.7l-0.9,1.4l1.7,2.1l1.5,8.6l-4.9-0.8l-1.4-7.2l-2.9-0.3l1,7l-4.9-0.6l-3.2-23.9l9.4,1.7 L240,66.6z M233,66.9l0.8,6l2.7,0.3l-1.1-5.9L233,66.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyk);
export default __webpack_public_path__ + "static/media/NYK.34afc78dd584a5f187d7e1e04a5f6ce4.svg";
export { ForwardRef as ReactComponent };